import { HttpClient } from './http-client';

const settings = (baseUrl: string, httpClient: HttpClient) => ({
  getConfig: (): Promise<{ version: string }> => httpClient(`${baseUrl}/config`),
  getManifest: (): Promise<{ version: string }> => httpClient(`/manifest.json`, { disableCache: true, disableAuth: true })
});

export default settings;
